import styled, { css } from "styled-components";
import { experienceEasterPath } from "../../../../paths";

import { IStyleProps } from "./interfaces";

export const StyledEmbed = styled.div<IStyleProps>`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    /* stylelint-disable */
    ${p => !p.isExperience && css`
        overflow: hidden;
        -webkit-mask-image: -webkit-radial-gradient(white, black);
    `}
    /* stylelint-enable */
`;

export const Pager = styled.div`
    position: absolute;
    bottom: 54px;
    right: 250px;
    left: 250px;
    text-align: center;
    transition: opacity 1000ms;
    z-index: 3;

    .button {
        &:focus {
            border-color: ${p => p.theme.c.active};
        }
    }
`;

export const ScoreWrapper = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    transform: scale(0.8);
    background-color: ${p => p.theme.c.whiteOnActive};
    border-radius: 24px;
    border: 3px solid black;
    overflow: hidden;
`;

export const ScorePositioner = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    transition: transform 1500ms;
    z-index: 3;
`;

export const Animation = styled.div`
    width: ${1280 * 5}px;
    position: absolute;
    top: 0;
    left: 0;
    transition: 1500ms;
`;

export const VideoScreen1 = styled.video`
    position: absolute;
    width: 1280px;
    left: 0;
    height: 720px;
    top: 0;
`;

export const Video1 = styled(VideoScreen1)`
    top: 720px;
`;

export const VideoScreen2 = styled(VideoScreen1)`
    top: 1440px;
`;
export const Video2 = styled(VideoScreen1)`
    top: 1440px;
    left: 1280px;
`;
export const VideoScreen3 = styled(VideoScreen1)`
    top: 1440px;
    left: ${1280 * 2}px;
`;
export const Video3 = styled(VideoScreen1)`
    top: 720px;
    left: ${1280 * 2}px;
`;
export const VideoScreen4 = styled(VideoScreen1)`
    top: 0;
    left: ${1280 * 2}px;
`;
export const Video4 = styled(VideoScreen1)`
    top: 0;
    left: ${1280 * 3}px;
`;
export const VideoScreen5 = styled(VideoScreen1)`
    top: 0;
    left: ${1280 * 4}px;
`;
export const Video5 = styled(VideoScreen1)`
    top: 720px;
    left: ${1280 * 4}px;
`;
export const VideoScreen6 = styled(VideoScreen1)`
    top: 1440px;
    left: ${1280 * 4}px;
`;

export const EasterBackground = styled.div`
    background-image: url("${experienceEasterPath}/easter-score-background.svg");
    position: absolute;
    background-size: 100% 100%;
`;

export const ChristmasBackground = styled.div`
    background-color: ${p => p.theme.c.christmasBlue};
    box-shadow: 0 0 0 6px ${p => p.theme.c.christmasLightBlue} inset;
    position: absolute;
`;